export default __webpack_public_path__ + "media/src/assets/images/cyan_filled-c4520e2e391e98be81f6edf19101cc2d.png";